import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import DataEngineeringPage from "@/pages/service/DataEngineeringPage";

export const Route = createFileRoute("/service/data-engineering")({
  head: () => pageHead("Data Engineering Services", "Knowledge graphs, vector databases, and scalable data pipelines for enterprise AI applications.", "/service/data-engineering", false),
  component: DataEngineeringPage,
});
